import globalStore from '@src/mobx-store/root-store/global-store';
import { thirdPartyAuthStore, xoyoAuthStore } from '@src/mobx-store/root-store/auth';

// noinspection SpellCheckingInspection
const rootStore = {
  globalStore,
  thirdPartyAuthStore,
  xoyoAuthStore
};

window.rootStore = rootStore;

export default rootStore;
